var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_vm._v("404 sorry guys")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'admin'}}},[_vm._v("Go back to admin")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }